import { Component, inject } from '@angular/core';
import { Event, NavigationEnd, NavigationStart, Router, RouterOutlet } from '@angular/router';
import { NavigationService } from './core/navigation/navigation.service';
import { PayeeService } from './services/payee.service';
import { NavigationMenus } from './helpers/app-constants';
import { SystemJobService } from './services/system-jobs.service';
import { CspService } from './services/csp-nonce-handler.service';
import { AuthService } from './core/auth/auth.service';
import { GtmService } from './services/gtm.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    standalone: true,
    imports: [RouterOutlet],
})
export class AppComponent {
    private _gtmService = inject(GtmService);

    /**
     * Constructor
     */
    constructor(
        private _router: Router,
        private _navigationService: NavigationService,
        private _payeeService: PayeeService,
        private _systemJobsService: SystemJobService,
        private _cspService: CspService,
        private _authService: AuthService
    ) {
        // add hook to state changes
        this._router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart && event.url.includes('/sign-up/user-account')) {
                this._authService.clearTokens();
            }

            // Push GTM virtual pageview when navigation completes
            if (event instanceof NavigationEnd) {
                this._gtmService.pushEvent({
                    event: 'page_view',
                    page_path: event.urlAfterRedirects
                })
            }

            if (this.isNavigationEvent(event)) {
                const navigations = this._navigationService.getNavigations();
                if (navigations?.default) {
                    this.handleIncompleteBillerMenu(navigations.default);
                    this.handleFailedSystemJobsMenu(navigations.default);
                }
            }
        });
    }
    ngOnInit() {
        //fetch nonce on component
        this._cspService.fetchNonce().subscribe({
            next: (res) => this._cspService.setNonce(res.nonce),
            error: (err) => console.error('Failed to fetch nonce', err),
        });
    }

    private isNavigationEvent(event: Event): boolean {
        return event instanceof NavigationEnd
            && !this.isExcludedUrl(event.url);
    }

    private isExcludedUrl(url: string): boolean {
        const excludedUrls = ['landing', 'mfa', 'sign-in', 'sign-out'];
        return excludedUrls.some(excluded => url.includes(excluded));
    }

    private handleIncompleteBillerMenu(defaultNavigations: any[]): void {
        const billerMenu = defaultNavigations.find(x => x.id == NavigationMenus.IncompleteBillerList);
        if (billerMenu) {
            this._payeeService.getIncompleteBillersCount().subscribe(itemCount => {
                this.updateMenuBadge(NavigationMenus.IncompleteBillerList, itemCount);
            });
        }
    }

    private handleFailedSystemJobsMenu(defaultNavigations: any[]): void {
        const systemJobsMenu = defaultNavigations.find(x => x.id == NavigationMenus.SystemJobsList);
        if (systemJobsMenu) {
            this._systemJobsService.getFailedSystemJobsCount().subscribe(itemCount => {
                this.updateMenuBadge(NavigationMenus.SystemJobsList, itemCount);
            })
        }
    }

    private updateMenuBadge(navId: string, itemCount: string) {
        if (navId && itemCount) {
            // Update the badge title
            this._navigationService.updateNavigationBadge(navId, itemCount);
        }
    }
}
